// All over the file changes has been done by Dev srini on 07/08/24


import { withStyles } from "@material-ui/core/styles";
import { Checkbox, FormControlLabel, Button } from "@material-ui/core";

import styles from "../OperationsStyles";

const FilterFields = ({ classes,  setStatus, checkboxToggle, handlecheckboxChange }) => {
  return (
    <div style={{ display: "flex", justifyContent: "end", width: "100%" }}>
      <form className={classes.kycFilterfield}>
        <span className={classes.checkBoxNew}>
          <FormControlLabel
            control={
              <Checkbox
              checked={checkboxToggle === "signed"}
                onChange={(e) => {
                
                  handlecheckboxChange(e, "signed");
                console.log('signed')
                }}
              />
            }
            label="Signed"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={checkboxToggle === "initiated"}
                onChange={(e) => {
                  setStatus(false)
                console.log('initiated')
                  handlecheckboxChange(e, "initiated");
                }}
              />
            }
            label="Initiated"
          />
           <FormControlLabel
            control={
              <Checkbox
                checked={checkboxToggle === "approved"}
                onChange={(e) => {
                  setStatus(false)
                console.log('approved')
                  handlecheckboxChange(e, "approved");
                }}
              />
            }
            label="Approved"
          />

           <FormControlLabel
            control={
              <Checkbox
                checked={checkboxToggle === "rejected"}
                onChange={(e) => {
                  setStatus(false)
                console.log('rejected')
                  handlecheckboxChange(e, "rejected");
                }}
              />
            }
            label="Rejected"
          />
        </span>

        {/* </LocalizationProvider> */}
      </form>
    </div>
  );
};

export default withStyles(styles)(FilterFields);
